import { Pipe, PipeTransform } from '@angular/core';
import { Account } from '../share/account/models/account.model';

@Pipe({
  name: 'instrumentModel',
})
export class InstrumentModelPipe implements PipeTransform {
  transform(account: Account): string {
    if (account.role === 'ADMIN') {
      return 'N/A';
    } else {
      return account.instrumentModel;
    }
  }
}
